import styled from 'styled-components';

export const Trending = styled.span`
  background-color: var(--red-lightest);
  height: 1.5rem;
`;

Trending.displayName = 'Trending';
